import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Recruitment Reason\n          ")
], -1);
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = { class: "col-span-6" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "reason",
    class: "block text-sm font-medium text-gray-700"
}, "What is the reason for recruiting this role? *", -1);
const _hoisted_8 = { class: "mt-1" };
const _hoisted_9 = ["value", "disabled"];
const _hoisted_10 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_11 = { class: "col-span-6" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", {
    for: "budget",
    class: "block text-sm font-medium text-gray-700"
}, "Is this role in budget?", -1);
const _hoisted_13 = { class: "mt-1" };
const _hoisted_14 = ["value", "disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("input", {
                                id: "reason",
                                type: "text",
                                name: "reason",
                                value: _ctx.formData?.recruitmentReason,
                                disabled: _ctx.disableForm,
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                            }, null, 8, _hoisted_9)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("input", {
                                id: "budget",
                                type: "text",
                                name: "budget",
                                value: _ctx.formData?.inBudget,
                                disabled: _ctx.disableForm,
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                            }, null, 8, _hoisted_14)
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
